import React, { FC } from 'react'

import { stopPropagation } from '~lib/helpers'
import usePortalRoots from '~lib/hooks/usePortalRoots'
import Menu from '~lib/ui-kit/Menu'
import Divider from '~shared/ui/Divider'

export interface AssetMenuProps {
  anchor: HTMLElement
  canUpload?: boolean
  canDownload?: boolean
  viewMode?: boolean
  copilotView?: boolean
  onShowDetailsClick: (ev: React.MouseEvent<HTMLElement>) => void
  onGenerateWithAIClick: (ev: React.MouseEvent<HTMLElement>) => void
  onDownloadClick: (ev: React.MouseEvent<HTMLElement>) => void
  onUploadClick: (ev: React.MouseEvent<HTMLElement>) => void
  onDeleteClick: (ev: React.MouseEvent<HTMLElement>) => void
  onSendForApproval: VoidFunction
  /**
   * hideUploadButton used to control to show or not upload asset button (currently if asset is collapsed we don't show this button at all, otherwise we show)
   */
  hideUploadButton?: boolean
}

const withStopPropagation = (callback: (...args: any[]) => void) => (ev: React.MouseEvent<HTMLElement>) => {
  stopPropagation(ev)
  callback(ev)
}

const AssetMenu: FC<React.PropsWithChildren<AssetMenuProps>> = ({
  viewMode,
  anchor,
  canUpload,
  canDownload,
  copilotView,
  onShowDetailsClick,
  onDownloadClick,
  onUploadClick,
  onDeleteClick,
  onSendForApproval,
  hideUploadButton = false,
}) => {
  const { popupRoot } = usePortalRoots()

  return (
    <Menu anchorEl={anchor} appendTo={popupRoot}>
      {!copilotView && <Menu.Item onClick={withStopPropagation(onShowDetailsClick)}>Expand</Menu.Item>}

      {!viewMode && (
        <Menu.Item disabled={!canDownload} onClick={withStopPropagation(onSendForApproval)}>
          Send for approval
        </Menu.Item>
      )}

      <Menu.Item disabled={!canDownload} onClick={withStopPropagation(onDownloadClick)}>
        Download asset
      </Menu.Item>

      {!hideUploadButton && (
        <Menu.Item disabled={!canUpload || viewMode} onClick={withStopPropagation(onUploadClick)}>
          Upload asset
        </Menu.Item>
      )}

      <Divider />

      <Menu.Item disabled={viewMode} onClick={withStopPropagation(onDeleteClick)} variant="accent">
        Delete
      </Menu.Item>
    </Menu>
  )
}

export default AssetMenu
